import gql from "graphql-tag";

export default gql`
  mutation fixInventoryDiagnosticItem($input: FixInventoryDiagnosticItemInput!) {
    fixInventoryDiagnosticItem(input: $input) {
      actions
      item {
        variantId
        productNumber
        serialNumber
        inventoryReserved
        expectedReserved
        currentAvailableToSell
        expectedAvailableToSell
        catalogProductIsSoldOut
        catalogGroupIsSoldOut
        issues
        fixDescription
      }
    }
  }
`;
